import { motion, useReducedMotion } from "framer-motion";

export default function Reveal({ children, delay = 0, className = "", as = "div" }) {
  const reduced = useReducedMotion();
  const MotionTag = motion[as] || motion.div;
  if (reduced) {
    return <div className={className}>{children}</div>;
  }
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </MotionTag>
  );
}

